import UnifiedTimeline from "../../shared/Timeline/UnifiedTimeline";

/** @deprecated Use UnifiedTimeline. Thin wrapper for marketplace staff orders. */
export default function AdminOrderTimeline({ entries = [] }) {
  return <UnifiedTimeline items={entries} showActor emptyMessage="No timeline entries yet." />;
}
